export default "__VITE_ASSET__zYabpjSt__"